// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"341":"66f870a6a6a3f675","472":"8a187b90a4661754"}[chunkId] + ".js";
};